// API借贷场景订单查询
import request from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { OrderStatusV2Enum } from '@/enums/orderV2';
import { OrderV2Po } from '@/po/orderV2';
import { landData } from '@/shared/utils/landData';
import { PreApplyItem } from '@/po/PreApplyItem';
import platform from '@/shared/utils/platform';
import { newGatewayUrl } from '@/constant';
import type { RepayDialogDataType } from '@/components/finance-replan/types';
import { OrdersV2, MoreCapitalRes, StuckContractRes } from './types';
import { LoanApplyMarketReqType } from '../apply-product/types';

// 用户审核的列表
export const preApplyLists = (): Promise<PreApplyItem[]> => request.postGate('f.credit.queryUserCreditHistory', {
  creditStatus: '',
  source: landData.getSouce(),
  ...platform.currentPlatformType,
}, { baseURL: newGatewayUrl });

// 下单结果查询
export const queryOrder = (
  loanOrderId: string,
  showLoading = true,
): Promise<{
  loanOrderVo: OrdersV2.OrderDetail;
  commodityDetailVO: OrdersV2.CommodityDetail;
  showMoreCapitalInfo: boolean;
}> => requestDefault.postGate('f.order.query.info',
  { loanOrderId },
  showLoading ? undefined : { showLoading: undefined });

export const getOrderList = (
  state: OrderStatusV2Enum = 10,
): Promise<OrderV2Po.ApplyItem[]> => request.postGate<OrderV2Po.ApplyItem[]>('f.order.orderList', { state, ...platform.currentPlatformType }, { baseURL: newGatewayUrl });

/** 兜底资方信息接口
 * yapi:https://yapi.hellobike.cn/project/3415/interface/api/375475
 */
export const getMoreCapital = (params: { loanOrderId: string}):
Promise<MoreCapitalRes> => requestDefault.postGate(
  'f.loan.show.more.capital',
  params,
  { showErrMsg: undefined },
);

/** 卡单页 获取资方协议信息接口
 * yapi:https://yapi.hellobike.cn/project/3415/interface/api/396289
 */
export const getStuckContract = (params: {
  loanOrderId: string;
  capitalCode: string;
}):
Promise<StuckContractRes> => requestDefault.postGate(
  'f.stuck.contract.batch.mgetCommodity',
  params,
  { showErrMsg: undefined },
);

/** 根据订单ID计算还款计划
 * @yapi: https://yapi.hellobike.cn/project/3415/interface/api/375484
 */
export const calcWithOrder = (params: {
  loanOrderId: string;
  /** 资方code 互兜不需要传*/
  capitalCode?: string;
  /** 计算场景 互兜不需要传 */
  calcScene?: string;
}):
Promise<RepayDialogDataType> => requestDefault.postGate(
  'f.loan.calc.with.order',
  params,
  { showErrMsg: undefined },
);

/** 同意兜底资方协议并申请提现
 * @yapi: https://yapi.hellobike.cn/project/3415/interface/api/375483
*/
export const applyWithMoreCapital = (params: {
  loanOrderId: string;
}): Promise<{
  result: boolean,
  msg: string,
}> => requestDefault.postGate(
  'f.loan.apply.more.capital',
  params,
);

/** 同意24资方权益卡单协议并申请下单
 * @yapi:
 * https://yapi.hellobike.cn/project/3415/interface/api/398654
*/
export const applyStuckOrder = (params: {
  /** 订单ID */
  loanOrderId: string;
  /** 24资方code */
  capitalCode: string;
  /** 利率 */
  interestDisplay: string;
  /** 权益相关参数 */
  loanApplyMarketReq: LoanApplyMarketReqType
}): Promise<{
  loanOrderId: string;
  msg: string;
}> => requestDefault.postGate(
  'f.loan.stuck.submit',
  params,
);


const OrdersApi = {
  preApplyLists,
  queryOrder,
  getOrderList,
};

export default OrdersApi;
